import { render, staticRenderFns } from "./message-count.vue?vue&type=template&id=7d028685&"
import script from "./message-count.vue?vue&type=script&lang=js&"
export * from "./message-count.vue?vue&type=script&lang=js&"
import style0 from "./message-count.vue?vue&type=style&index=0&id=7d028685&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports